<template>
  <div>
    <div class="grid grid-cols-1 sm:grid-cols-3 bg-gray-900">
      <div v-for="review in reviews" :key="review.id" class="p-4">
        <div
          class="relative bg-gray-800 rounded-xl overflow-hidden h-96 shadow-xl p-4"
        >
          <div
            class="cursor-pointer"
            @click="showImage(review.image_url)"
            v-if="review.review == null"
          >
            <img
              :src="review.image_url"
              alt=""
              class="w-full h-full object-cover"
            />
          </div>

          <div class="" v-else>
            <div class="absolute inset-0 opacity-90 mix-blend-multiply">
              <img
                v-if="review.image_url"
                :src="review.image_url"
                alt=""
                class="w-full h-full object-cover"
              />
              <!-- <img v-else src="https://homemanagerfortesting.s3.amazonaws.com/logo360.png" alt="" class="w-full h-full object-cover"> -->
            </div>
            <div class="relative">
              <img
                class="h-12 w-auto"
                src="https://homemanagerfortesting.s3.amazonaws.com/logo360.png"
                alt=""
              />
              <blockquote class="mt-2 text-white">
                <svg
                  class="h-12 w-12 text-indigo-500 opacity-50"
                  fill="currentColor"
                  viewBox="0 0 32 32"
                  aria-hidden="true"
                >
                  <path
                    d="M9.352 4C4.456 7.456 1 13.12 1 19.36c0 5.088 3.072 8.064 6.624 8.064 3.36 0 5.856-2.688 5.856-5.856 0-3.168-2.208-5.472-5.088-5.472-.576 0-1.344.096-1.536.192.48-3.264 3.552-7.104 6.624-9.024L9.352 4zm16.512 0c-4.8 3.456-8.256 9.12-8.256 15.36 0 5.088 3.072 8.064 6.624 8.064 3.264 0 5.856-2.688 5.856-5.856 0-3.168-2.304-5.472-5.184-5.472-.576 0-1.248.096-1.44.192.48-3.264 3.456-7.104 6.528-9.024L25.864 4z"
                  />
                </svg>
                <div class="descinline text-base font-medium ">
                  {{ review.review | shortText(300) }}
                  <a
                    class="linkCustom"
                    v-if="review.review.length >= 300"
                    @click="toggler(review)"
                    ><span class="text-white -ml-2">...</span> Continue reading
                  </a>
                </div>
                <div class="descempty text-base font-medium ">
                  {{ review.review }}
                </div>

                <footer class="mt-6">
                  <p class="text-indigo-400 flex flex-col font-medium">
                    <span>{{ review.name }}</span>
                  </p>
                </footer>
              </blockquote>
            </div>
          </div>
        </div>
      </div>

      <div v-if="showModal">
        <div
          class="fixed z-10 inset-0 overflow-y-auto"
          aria-labelledby="modal-title"
          role="dialog"
          aria-modal="true"
        >
          <div
            class="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0"
          >
            <div
              class="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity"
              aria-hidden="true"
            ></div>

            <!-- This element is to trick the browser into centering the modal contents. -->
            <span
              class="hidden sm:inline-block sm:align-middle sm:h-screen"
              aria-hidden="true"
              >&#8203;</span
            >

            <div
              class="inline-block align-center bg-gray-900 rounded-lg px-4 pt-5 pb-4 text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-3xl sm:w-full sm:p-6"
            >
              <img
                v-if="selectedImage"
                :src="selectedImage"
                alt=""
                class="w-full h-full object-cover"
              />

              <section
                v-if="singleReview"
                class="py-12 bg-gray-50 overflow-hidden md:py-20 lg:py-24"
              >
                <div class="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                  <svg
                    class="absolute top-full right-full transform translate-x-1/3 -translate-y-1/4 lg:translate-x-1/2 xl:-translate-y-1/2"
                    width="404"
                    height="404"
                    fill="none"
                    viewBox="0 0 404 404"
                    role="img"
                    aria-labelledby="svg-workcation"
                  >
                    <title id="svg-workcation">Workcation</title>
                    <defs>
                      <pattern
                        id="ad119f34-7694-4c31-947f-5c9d249b21f3"
                        x="0"
                        y="0"
                        width="20"
                        height="20"
                        patternUnits="userSpaceOnUse"
                      >
                        <rect
                          x="0"
                          y="0"
                          width="4"
                          height="4"
                          class="text-gray-200"
                          fill="currentColor"
                        />
                      </pattern>
                    </defs>
                    <rect
                      width="404"
                      height="404"
                      fill="url(#ad119f34-7694-4c31-947f-5c9d249b21f3)"
                    />
                  </svg>

                  <div class="relative">
                    <img
                      class="mx-auto h-24"
                      src="https://homesby360.s3.amazonaws.com/360.png"
                      alt="Workcation"
                    />
                    <blockquote class="mt-10">
                      <div
                        class="max-w-3xl mx-auto text-center text-base leading-9 font-medium text-gray-900"
                      >
                        <p class="whitespace-pre-wrap">
                          &ldquo;{{ singleReview.review }}.&rdquo;
                        </p>
                      </div>
                      <footer class="mt-8">
                        <div class="md:flex md:items-center md:justify-center">
                          <div class="md:flex-shrink-0">
                            <img
                              class="mx-auto h-10 w-10 rounded-full"
                              :src="url + singleReview.name + rest"
                              alt=""
                            />
                          </div>
                          <div
                            class="mt-3 text-center md:mt-0 md:ml-4 md:flex md:items-center"
                          >
                            <div class="text-base font-medium text-gray-900">
                              {{ singleReview.name }}
                            </div>

                            <svg
                              class="hidden md:block mx-1 h-5 w-5 text-indigo-600"
                              fill="currentColor"
                              viewBox="0 0 20 20"
                            >
                              <path d="M11 0h3L9 20H6l5-20z" />
                            </svg>
                          </div>
                        </div>
                      </footer>
                    </blockquote>
                  </div>
                </div>
              </section>

              <div class="mt-5 sm:mt-6 sm:flex justify-center">
                <v-btn
                  @click="closeModal"
                  small
                  class="profile-card__button button--silver text-center"
                >
                  Close
                </v-btn>

                <v-btn
                  small
                  href="tel:19106510743"
                  target="_blank"
                  class="profile-card__button button--blue"
                  dark
                >
                  Questions? Call Us
                </v-btn>

                <v-btn
                  @click="redirectListing"
                  class="profile-card__button button--orange text-center"
                  dark
                >
                  Find YOUR dream home
                </v-btn>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: ["singleRev", "singleImage"],
  data() {
    return {
      reviews: [],
      selectedImage: "",
      showModal: false,
      singleReview: "",
      url: "https://ui-avatars.com/api/?name=",
      rest: "&background=ccf3ff&color=0099cc"
    };
  },

  created() {
    this.getReviews();
  },

  mounted() {
    if (this.singleRev) {
      this.singleReview = this.singleRev;
      this.showModal = true;
    } else if (this.singleImage) {
      this.selectedImage = this.singleImage;
      this.showModal = true;
    }
  },

  filters: {
    shortText(value, limit) {
      if (value) {
        return value.substring(0, limit);
      }
    }
  },

  methods: {
    redirectListing() {
      this.$router.push({ name: "listings" });
    },

    toggler(review) {
      this.singleReview = review;
      this.showModal = true;
    },

    getReviews() {
      window.axios.get("/api/reviews").then(res => {
        this.reviews = res.data;
      });
    },

    showImage(url) {
      this.selectedImage = url;
      this.showModal = true;
    },

    closeModal() {
      this.singleReview = "";
      this.selectedImage = "";
      this.showModal = false;
    }
  }
};
</script>

<style>
.bg-image {
  background-color: #fafafa;
  background-image: url("https://revistaaxxis.com.co/wp-content/uploads/2019/09/llano-axxis1.jpg");
}

.descempty {
  display: none;
}
.descinline {
  display: block;
}
.linkCustom {
  color: #00bbff !important;
  cursor: pointer;
}

.linkCustom:hover {
  color: #0779a2 !important;
  text-decoration: underline !important;
  cursor: pointer;
}
</style>
